/* eslint-disable react/prop-types */
import React from 'react';

import TextArea from '@zg-rentals/multibrand-ui/lib/TextArea';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import './style.scss';

const REQUIRED_REVIEW_LENGTH = 40;

class ReviewProperty extends React.Component {
  getMinimumText = (requiredLength) => {
    const { propertyReview } = this.props;

    if (!propertyReview || propertyReview.length < 1) {
      return `${requiredLength} minimum`;
    } else if (propertyReview.length < requiredLength) {
      return `${requiredLength - propertyReview.length}`;
    } else {
      return '';
    }
  };

  render() {
    const { onBack, onNext, onReviewChange, propertyReview } = this.props;

    return (
      <div className="ReviewProperty">
        <div className="stacked-lg">
          <TextArea
            className="ReviewProperty-minimum-textarea"
            label="Share your thoughts on the property."
            placeholder="Tell us a bit more about the rating you gave. Share your highlights or details about the property and it's condition."
            onChange={onReviewChange}
            value={propertyReview}
          />
          <Text lowlight type="body-small" className="ReviewProperty-minimum-text">
            {this.getMinimumText(REQUIRED_REVIEW_LENGTH)}
          </Text>
        </div>
        <div className="ReviewPoperty-nav">
          <Link onClick={onBack} type="secondary">
            Back
          </Link>
          <Button onClick={onNext} type="primary" disabled={propertyReview.length < REQUIRED_REVIEW_LENGTH}>
            Next
          </Button>
        </div>
      </div>
    );
  }
}

ReviewProperty.defaultProps = {
  onNext: () => {},
  onBack: () => {},
  propertyRating: 0,
};

export default ReviewProperty;
